import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Remove the session items
        sessionStorage.removeItem("isLoggedIn");
        sessionStorage.removeItem("authToken");

        // Redirect to the root (home page)
        navigate("/");
    }, [navigate]);

    return (
        <div>
            Logging out...
        </div>
    );
};

export default LogoutPage;